export default "__VITE_ASSET__DR4$znHY__"